import { PaletteGradient, ThemeGradientsColors } from "./palette.types";

//Base colors
export const blue = "#5F8AFA";
export const lightGreen = "#30C3A3";
export const green = "#037F7F";
export const gold = "#E5BA0E";
export const darkGold = "#AF8F0F";
export const red = "#F22D50";
export const aqua = "#4FD1D9";
export const purple = "#43398E";
export const lilac = "#A463B0";
export const lavender = "#EAE8F5";
export const orange = "#F9744B";
export const white = "#FFFFFF";
export const black = "#292730";
export const info = "#0288D1";
export const success = green;
export const warning = "#F57C00";
export const error = "#DB5555";
export const violet = "#43398E";
export const yellow = "#FFE473";
export const lightViolet = "#F0EFF6";

//Base gradients
const greenDarkGreen: PaletteGradient = [lightGreen, green];
export const gradient: ThemeGradientsColors = {
    blueTurquoise: [blue, aqua],
    lilacBlue: [lilac, blue],
    lilacOrange: [lilac, orange],
    lilacRed: [lilac, red],
    blueGreen: [blue, green],
    bluePurple: [blue, purple],
    purpleLilac: [purple, lilac],
    purpleTurquoise: [purple, aqua],
    purpleRed: [purple, red],
    redOrange: [red, orange],
    orangeYellow: [orange, gold],
    greenYellow: [green, gold],
    greenDarkGreen,
    primary: greenDarkGreen,
};
